/**
 * @author salla.saishiva
 * @Date: 2023-09-14 11:30:49
 * @Last Modified by: salla.saishiva
 * @Last Modified time: 2023-09-14 16:30:49
*/

const BOARD_OF_DIRECTORS = Object.freeze({
  BOARD_OF_DIRECTORS_ENDPOINTS: [
    'raj-p-narayanam',
    'avinash-ramesh-godkhindi',
    'arun-vijaykumar-gupta',
    'aravamudan-krishna-kumar',
    'abhay-deshpande-raosaheb',
    'prerna-tandon',
  ],

  BOARD_OF_DIRECTORS_OVERVIEW: [
    {
      id: 0,
      redirectLink: 'raj-p-narayanam',
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/raj-p-narayanam.webp',
      imgAlt: 'Raj P Narayanam Executive Chairman',
      title: 'Mr. Raj P Narayanam',
      desgination: 'Executive Chairman',
    },
    {
      id: 1,
      redirectLink: 'avinash-ramesh-godkhindi',
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/avinash-ramesh-godkhindi.webp',
      imgAlt: 'Avinash Ramesh Godkhindi MD & CEO',
      title: 'Mr. Avinash Ramesh Godkhindi',
      desgination: 'Managing Director and Chief Executive Officer',
    },
    {
      id: 2,
      redirectLink: 'arun-vijaykumar-gupta',
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/arun-vijaykumar-gupta.webp',
      imgAlt: 'Arun Vijaykumar Gupta Non-Executive Director',
      title: 'Mr. Arun Vijaykumar Gupta',
      desgination: 'Non-Executive Director',
    },
    {
      id: 3,
      redirectLink: 'aravamudan-krishna-kumar',
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/aravamudan-krishna-kumar.webp',
      imgAlt: 'Aravamudan Krishna Kumar Independent Director',
      title: 'Mr. Aravamudan Krishna Kumar',
      desgination: 'Independent Director',
    },
    {
      id: 4,
      redirectLink: 'abhay-deshpande-raosaheb',
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/abhay-deshpande-raosaheb.webp',
      imgAlt: 'Abhay Deshpande Raosaheb Independent Director',
      title: 'Mr. Abhay Deshpande Raosaheb',
      desgination: 'Independent Director',
    },
    {
      id: 5,
      redirectLink: 'prerna-tandon',
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/prerna-tandon.webp',
      imgAlt: 'Prerna Tandon Independent Director',
      title: 'Mrs. Prerna Tandon',
      desgination: 'Independent Director',
    },
  ],

  DIRECTORS_PROFILES: {
    'raj-p-narayanam': [{
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/raj-p-narayanam.webp',
      imgAlt: 'Raj P Narayanam Executive Chairman',
      title: 'Mr. Raj P Narayanam',
      designation: 'Executive Chairman',
      description: `
        <p class="text-black font-14">
          Raj P Narayanam is the Executive Chairman of our Company. He has been on the Board of our Company since April 30, 2012. He completed post graduate diploma in business management with specialisation in finance from the FORE School of Management, New Delhi. He has also completed his post graduate diploma on “Computer Systems” from Advance Computer Education and a certified online course on “Scaling a Business: How to Build a USD 1 Billion+ Unicorn” from The Wharton School, University of Pennsylvania. Further, he has completed an online programme and has been awarded the post graduate certificate in digital marketing from MICA, The School of Ideas. He has experience in the technology and fintech industry. He has also made varying levels of investments in certain companies at different points in time.
        </p>
      `,
    }],
    'avinash-ramesh-godkhindi': [{
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/avinash-ramesh-godkhindi.webp',
      imgAlt: 'Avinash Ramesh Godkhindi MD & CEO',
      title: 'Mr. Avinash Ramesh Godkhindi',
      designation: 'Managing Director and Chief Executive Officer',
      description: `
        <p class="text-black font-14">
          Avinash Ramesh Godkhindi is the Managing Director and Chief Executive officer of our Company. He has been on the Board of our Company since May 7, 2012. He holds a bachelors’ degree in engineering from Bangalore University, Bengaluru and a masters’ degree in business administration from the University of Chicago, Chicago. He has been awarded the “Inspiring CEO” award by the Economic Times in 2022. Prior to this, he worked as an Assistant Vice President at Citibank N.A., India.
        </p>
      `,
    }],
    'arun-vijaykumar-gupta': [{
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/arun-vijaykumar-gupta.webp',
      imgAlt: 'Arun Vijaykumar Gupta Non-Executive Director',
      title: 'Mr. Arun Vijaykumar Gupta',
      designation: 'Non-Executive Director',
      description: `
        <p class="text-black font-14">
          Arun Vijaykumar Gupta is a Non-Executive Director of our Company. He has been on the Board of our Company since September 26, 2022. He holds a bachelors’ degree in commerce from the P.D. Lion’s College of Commerce and Economics, University of Bombay. Currently, he is a director at Route Mobile Limited.
        </p>
      `,
    }],
    'aravamudan-krishna-kumar': [{
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/aravamudan-krishna-kumar.webp',
      imgAlt: 'Aravamudan Krishna Kumar Independent Director',
      title: 'Mr. Aravamudan Krishna Kumar',
      designation: 'Independent Director',
      description: `
        <p class="text-black font-14">
          Aravamudan Krishna Kumar is an Independent Director of our Company. He has been on the Board of our Company since September 26, 2022. He holds a bachelors’ degree in arts and economics (honors’ course) from the University of Delhi, Delhi. He is a certified associate of the Indian Institute of Bankers and has experience in the banking industry. Prior to this, he worked at the State Bank of India.
        </p>
      `,
    }],
    'abhay-deshpande-raosaheb': [{
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/abhay-deshpande-raosaheb.webp',
      imgAlt: 'Abhay Deshpande Raosaheb Independent Director',
      title: 'Mr. Abhay Deshpande Raosaheb',
      designation: 'Independent Director',
      description: `
        <p class="text-black font-14">
          Abhay Deshpande Raosaheb is an Independent Director of our Company. He has been on the Board of our Company since August 22, 2022. He holds a bachelors’ degree in computer science and engineering from the Dr. Babasaheb Ambedkar Marathwada University, Aurangabad, Maharashtra. He has experience in the IT industry and is currently a director at Payswiff Technologies Private Limited.
        </p>
      `,
    }],
    'prerna-tandon': [{
      imgUrl: 'https://cdn.zaggle.in/images/web/zaggle/team/directors/prerna-tandon.webp',
      imgAlt: 'Prerna Tandon Independent Director',
      title: 'Mrs. Prerna Tandon',
      designation: 'Independent Director',
      description: `
        <p class="text-black font-14">
          Prerna Tandon is an Independent Director of our Company. She has been on the Board of our Company since September 26, 2022. She holds a masters’ degree in business administration from the Panjab University, Chandigarh. Prior to this, she has worked as the vice president – operations at Infosys BPO Limited and vice president – productivity and digitization leader at Genpact India.
        </p>
      `,
    }],
  },
});

export {
  BOARD_OF_DIRECTORS,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/BoardOfDirectors/constants.js